<script setup lang="ts">
import { SectionApplianceCard } from "@voltalis/ui-kit/components";
import { inject } from "vue";

import {
  IMoveSectionAppliancesWizardInject,
  MoveSectionAppliancesWizardInject,
} from "@/app/tools/new-section-management/site-sections-tree/section-appliances/move-section-appliances-wizard/move-section-appliances-wizard.types";
import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";

const context = inject<IMoveSectionAppliancesWizardInject>(MoveSectionAppliancesWizardInject)!;
</script>

<template>
  <div
    class="w-full border-b border-t flex flex-col max-h-[500px] px-6 pt-8 gap-[18px]"
    :data-test-id="DATA_TEST_IDS.components.moveSectionAppliancesWizard.migrationSummaryStep.wizardTab"
  >
    <div class="flex items-center gap-2">
      <i class="pi pi-arrow-right" />
      <span
        class="text-base font-semibold"
        :data-test-id="DATA_TEST_IDS.components.moveSectionAppliancesWizard.migrationSummaryStep.targetSectionName"
        >{{ context.selectedTargetSection?.name }}</span
      >
    </div>

    <div
      class="grid grid-cols-3 gap-[18px] h-full overflow-y-auto pb-8"
      :data-test-id="DATA_TEST_IDS.components.moveSectionAppliancesWizard.migrationSummaryStep.selectedAppliancesList"
    >
      <SectionApplianceCard
        v-for="appliance in context.selectedAppliances"
        :key="appliance.applianceId"
        :appliance="appliance"
      />
    </div>
  </div>
</template>
